import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4eef6b9d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "body-container"
};
const _hoisted_4 = {
  class: "notice-box"
};
const _hoisted_5 = {
  class: "new_header"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "classify-box"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "news-list"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "main-notice-content"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["title"];
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  key: 0,
  class: "right_icon"
};
const _hoisted_18 = {
  class: "date_box"
};
const _hoisted_19 = {
  class: "year"
};
const _hoisted_20 = {
  class: "day"
};
const _hoisted_21 = {
  key: 2,
  class: "no-data"
};
const _hoisted_22 = {
  class: "more"
};
const _hoisted_23 = ["href"];

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Right = _resolveComponent("Right");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_ArrowRight = _resolveComponent("ArrowRight");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_8);
  }), 128))], 2)]), _createElementVNode("div", _hoisted_9, [$data.mainRecommendNews ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "main-notice",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleLookDetail($data.mainRecommendNews))
  }, [_createElementVNode("img", {
    src: $data.mainRecommendNews ? $data.mainRecommendNews.news_cover_url : ''
  }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "main-notice-top",
    title: $data.mainRecommendNews.news_name
  }, [_createElementVNode("div", _hoisted_13, _toDisplayString($data.mainRecommendNews.news_name), 1)], 8, _hoisted_12)])])) : _createCommentVNode("", true), $data.newsList.length ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["notice-list", {
      'notice-list-four': $data.mainRecommendNews
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(index != 0 && index != 1 ? 'new_small' : 'notice-item'),
      onClick: $event => $options.handleLookDetail(item),
      key: index
    }, [_createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_15), _createElementVNode("div", {
      class: "new-intro",
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_16), index != 0 && index != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Right)]),
      _: 1
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY.MM')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'DD')), 1), _createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
      _: 1
    })])], 10, _hoisted_14);
  }), 128))], 2)) : _createCommentVNode("", true), !$data.mainRecommendNews && $data.newsList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_Empty, {
    type: "message"
  })])) : _createCommentVNode("", true)])])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
    href: `/notice.html?menuId=${$props.menu.menu_id}`
  }, [_hoisted_24, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })], 8, _hoisted_23)])]);
}